// src/components/Unauthorized.jsx
import React from 'react';

function Unauthorized() {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>⛔ Acceso no autorizado</h2>
      <p>No tienes permisos para ver esta sección.</p>
    </div>
  );
}

export default Unauthorized;
